import React, { useState } from 'react';
import { PageLayout } from '../../components/PageLayout';
import { createNewsletterSignup } from 'src/services/newsletter.service';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from 'src/components/Loading/LoadingSpinner';
import GenericErrorMessage from 'src/components/Error/GenericErrorMessage';

export const NewsletterSignupPage: React.FC = () => {
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const navigate = useNavigate();

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	};

	const handleSubmit = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
		setError(null);
		setMessage('');
		setIsLoading(true);
		const sessionData = { email: email };
		const { data, error } = await createNewsletterSignup(
			sessionData
		);

		if (error) {
			setError(error.message);
			setIsLoading(false);
			return;
		}

		setIsLoading(false);
		setMessage(
			'Thank you for signing up! A verification email has been sent to your inbox.'
		);
		// setTimeout(() => {
		// 	window.history.replaceState(null, "");
		// 	navigate("/", { replace: true });
		// }, 5000);
	};

	return (
		<PageLayout>
			{error && <GenericErrorMessage message={error} onClose={() => setError(null)} />}
			<div className="newsletter-signup">
				<div>
					<h2 className="stock-filings__title">
						Sign Up for Our Newsletter
						<p className="hero-banner__headline__3">
							Stay ahead with exclusive insider insights and market trends
							delivered straight to your inbox.
						</p>
					</h2>
				</div>
				<form className="newsletter-signup__form" onSubmit={handleSubmit}>
					<input
						type="email"
						value={email}
						onChange={handleInputChange}
						placeholder="Enter your email"
						className="newsletter-signup__input"
						required
					/>
					<button type="submit" className="newsletter-signup__button">
						Subscribe
					</button>
				</form>
				{isLoading && <LoadingSpinner message="Signing up..." />}
				{message && 
				(
				<div>
					<p className="newsletter-signup__message">
						{message}
					</p>
				</div>
				)}

			</div>
		</PageLayout>
	);
};

export default NewsletterSignupPage;
